import tintgLogo from "@/assets/case-studies/beon-ti-ntg-logo.png";
import happyTeamImage from "@/assets/case-studies/happy-employees-team.jpg";
import nataliePhoto from "@/assets/case-studies/natalie-cook.jpeg";
import mmlcLogo from "@/assets/case-studies/mmlc-logo.webp";
import mmlcHeroImage from "@/assets/case-studies/mmlc-hero.jpg";
import jessicaPhoto from "@/assets/case-studies/jessica-redmond.jpeg";

export interface CaseStudy {
  companyName: string;
  headline: string;
  summary: string;
  metric: string;
  logo: string;
  image: string;
  slug: string;
  authorName: string;
  authorTitle: string;
  authorPhoto: string;
  quote: string;
}

export const caseStudies: CaseStudy[] = [
  {
    companyName: "TI/NTG",
    headline: "How TI/NTG Built a Culture of Employee Recognition and Connection",
    summary: "Transforming employee recognition from ad-hoc gestures to a structured, company-wide culture of appreciation and connection.",
    metric: "85% recognized monthly",
    logo: tintgLogo,
    image: happyTeamImage,
    slug: "ti-ntg",
    authorName: "Natalie Cook",
    authorTitle: "VP, Employee Experience, TI/NTG",
    authorPhoto: nataliePhoto,
    quote: "Recognition became part of our daily rhythm.",
  },
  {
    companyName: "Minding Miracles Learning Center",
    headline: "How Minding Miracles Learning Center Brought Every Building Together with Assembly",
    summary: "Building bonds beyond classrooms with unified recognition across three preschools and an Adult Center.",
    metric: "Company-wide participation",
    logo: mmlcLogo,
    image: mmlcHeroImage,
    slug: "mmlc",
    authorName: "Jessica Redmond",
    authorTitle: "Preschool Teacher, Minding Miracles Learning Ctr",
    authorPhoto: jessicaPhoto,
    quote: "The participation and morale have both improved so much.",
  },
];
